module.exports = __webpack_public_path__ + "static/img/hetao.91540f75.png";